// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"42a8f3fd","157":"ac3ca66b","182":"f2051c87","355":"b1b89664","387":"c28b8cf7","451":"a142c89d","484":"89f73eb1","661":"339713b8","699":"5de642b9","741":"c2592ba7","785":"dfe6496f","855":"c7b7af76"}[chunkId] + ".chunk.js";
};